export const FormErrorCodes = Object.freeze({
  NO_RECAPTCHA_CODE: 'NO_RECAPTCHA_CODE',
  INVALID_EMAIL: 'INVALID_EMAIL',
  REQUIRED_FIELD_EMPTY: 'REQUIRED_FIELD_EMPTY',
  RECAPTCHA_FAILED: 'RECAPTCHA_FAILED',
  UNABLE_TO_SUBMIT_FORM: 'UNABLE_TO_SUBMIT_FORM'
});

export const FormStatus = Object.freeze({
  IDLE: 'IDLE',
  SENDING: 'SENDING',
  SENT: 'SENT',
})
